/* eslint-disable react/jsx-handler-names */
/* eslint-disable max-statements */
/* eslint-disable complexity */
/* eslint-disable max-nested-callbacks */
import React, { useEffect, useRef, useState, useCallback } from "react";
import styles from "./styles.css";
import closeIcon from "./images/close.svg";
import wishlistIcon from "./images/wishlist.svg";
import muteIcon from "./images/mute.svg";
import unmuteIcon from "./images/unmute.svg";
import PropTypes from "prop-types";
import { NUMBER, PAGE_SOURCE } from "../../../constants/app-constants";
import wishlistFilledIcon from "./images/filled-wishlist.svg";
import useCarDetailsCta from "../../../hooks/useCarDetailsCta";
import CarDetailsCardRevamp from "../car-details-card-revamp";
import { carDetailUrlAu, getMyBookingCarDetailsURL } from "../../../utils/helpers/get-detail-page-url";
import { postOrderBookingConfirmed } from "../../../utils/helpers/post-order-placed-confirmed";
import { trackDesktopCustomEventsAU } from "../../../tracking";
import { VIDEO_CATALOG_AMPLITUDE_EVENTS, VIDEO_CATALOG_GA_EVENTS_DESKTOP } from "./tracking";
import debounce from "lodash.debounce";
import CarReservationNotifyModal from "../car-reservation-notify-modal";
import left from "./images/left.svg";
import right from "./images/right.svg";

// Debounced scroll handler hook
const useDebouncedScroll = (onScrollEnd) => {
    const debounced = useRef(
        debounce(() => {
            onScrollEnd();
        }, NUMBER.TWO_HUNDRED)
    ).current;
    return useCallback(() => {
        debounced();
    }, [debounced]);
};

const VideoGallerySlider = (
    {
        carDetails,
        content,
        onClose,
        chapters,
        videoUrl,
        // source,
        orderStatus,
        secureToken,
        isLoggedIn,
        isWishlistedCar,
        onClickAddToWishList,
        orderId,
        createOrderConnect,
        updateOrderConnect,
        updateValidC2bOrderConnect,
        setCheckoutLoginTypeConnect,
        openLoginPopupConnect,
        setOnLoginSuccessCallback,
        showTradeInCheckoutStep,
        preApproved,
        financeOpted,
        financeProvider,
        preApprovalType,
        financeFirstCheckoutRevamp,
        DRIVA_MIN_LOAN_AMOUNT_OFFERED,
        isUserZeroDpVariant,
        initialChapterIndex = 0,
        calculatorRef,
        scrollToSection,
        isFetchingOrderDetails,
        source = PAGE_SOURCE.CDP,
        fetchSimilarCarsConnect,
        fireEwSkippedCTEvent,
        order,
        step,
        getCheckoutStepsConnect,
        getOrderDetailConnect,
        userGeoData,
        drivingLicenceStatus,
        testDriveConfig,
        gaId,
        email,
        phoneNumberVerified,
        leadAppointment,
        createClassifiedLeadConnect,
        desktopComingSoon
    }
) => {
    const iframeRef = useRef(null);
    const playerInstanceRef = useRef(null);
    const [player, setPlayer] = useState(null);
    const [isReady, setIsReady] = useState(false);
    const [isMuted, setIsMuted] = useState(true);
    const [activeChapterIndex, setActiveChapterIndex] = useState(
        Math.max(0, Math.min(initialChapterIndex, (chapters?.length || 1) - 1))
    );
    const hasInitialSeekDoneRef = useRef(false);
    const thumbnailWrapperRef = useRef(null);
    const [canScrollRight, setCanScrollRight] = useState(true);
    const [canScrollLeft, setCanScrollLeft] = useState(false);
    // Function to append user data to video URL
    const getVideoPlayerUrlWithUserData = () => {
        if (!videoUrl) return "";

        let url = videoUrl;
        const params = [];

        if (gaId) {
            params.push(`gm_user_id=${encodeURIComponent(gaId)}`);
        }

        if (email) {
            params.push(`gum_user_email=${encodeURIComponent(email)}`);
        }

        if (params.length > 0) {
            const separator = url.includes("?") ? "&" : "?";
            url = `${url}${separator}${params.join("&")}`;
        }

        // eslint-disable-next-line no-console, no-undef
        console.log("Desktop Gumlet Player Final URL:", url);
        return url;
    };

    // Helper to get new chapter index
    const getNewChapterIndex = (data, chapterList) => {
        // Find the chapter where data.seconds is between startTime (inclusive) and endTime (exclusive)
        return chapterList.findIndex(
            (chapter) => data.seconds >= chapter.startTime && data.seconds < chapter.endTime
        );
    };

    // Check if we can scroll left or right
    const checkScrollState = () => {
        if (thumbnailWrapperRef.current) {
            const container = thumbnailWrapperRef.current;
            const canScrollToRight = container.scrollLeft < container.scrollWidth - container.offsetWidth - 1;
            const canScrollToLeft = container.scrollLeft > 0;
            setCanScrollRight(canScrollToRight);
            setCanScrollLeft(canScrollToLeft);
        }
    };

    const showTestDriveLocationVariant = true;
    const { eligibleStateNames = [] } = testDriveConfig?.data || {};

    const ctaHook = useCarDetailsCta({
        carId: content.appointmentId,
        content,
        config: content.config,
        isWishlistedCar,
        onClickAddToWishList,
        isLoggedIn,
        secureToken,
        comingSoon: content.comingSoon,
        make: content.make,
        model: content.model,
        appointmentId: content.appointmentId,
        orderId,
        orderStatus,
        isExtendedWarrantySelected: content.isExtendedWarrantySelected,
        updateOrderConnect,
        createOrderConnect,
        updateValidC2bOrderConnect,
        setCheckoutLoginTypeConnect,
        openLoginPopupConnect,
        setOnLoginSuccessCallback,
        egc: content.egc,
        showTradeInCheckoutStep,
        eligibleForExtendedWarranty: content.eligibleForExtendedWarranty,
        step,
        preApproved,
        financeOpted,
        financeProvider,
        preApprovalType,
        financeFirstCheckoutRevamp,
        DRIVA_MIN_LOAN_AMOUNT_OFFERED,
        isUserZeroDpVariant,
        source,
        postOrderBookingConfirmed,
        booked: content.booked,
        listingActive: content.listingActive,
        reserved: content.reserved,
        similarCars: content.similarCars || [],
        fetchSimilarCarsConnect,
        fireEwSkippedCTEvent,
        showTestDriveLocationVariant,
        testDriveStatus: order?.testDriveStatus,
        getMyBookingCarDetailsURL,
        getCheckoutStepsConnect,
        getOrderDetailConnect,
        carDetails,
        isVideoGallery: true,
        eligibleStateNames,
        userGeoData,
        calledFrom: "desktop",
        drivingLicenceStatus,
        phoneNumberVerified,
        leadAppointment,
        createClassifiedLeadConnect,
        order
    });

    const carName = `${content.make || ""} ${content.model || ""}`;

    const { relativeURL } = carDetailUrlAu({ year: content.year, carName, carId: content.appointmentId });

    useEffect(() => {
        let timeout;
        import("player.js").then((module) => {
            const playerjs = module.default || module;
            timeout = window.setTimeout(() => {
                if (iframeRef.current) {
                    const playerInstance = new playerjs.Player(iframeRef.current);
                    playerInstanceRef.current = playerInstance;

                    playerInstance.on("ready", () => {
                        setPlayer(playerInstance);
                        setIsReady(true);
                        if (!hasInitialSeekDoneRef.current && chapters?.[activeChapterIndex]) {
                            playerInstance.setCurrentTime(chapters[activeChapterIndex].startTime);
                            hasInitialSeekDoneRef.current = true;
                        }
                        playerInstance.play();
                        window.setTimeout(() => {
                            playerInstance.getMuted((actualMuted) => {
                                setIsMuted(actualMuted);
                            });
                        }, NUMBER.ONE_HUNDRED);
                    });

                    playerInstance.on("timeupdate", (data) => {
                        const newChapterIndex = getNewChapterIndex(data, chapters);
                        if (newChapterIndex !== activeChapterIndex) {
                            setActiveChapterIndex(newChapterIndex);
                        }
                    });
                }
            }, NUMBER.ONE_HUNDRED); // 100ms delay to ensure iframe is mounted
        });

        return () => {
            window.clearTimeout(timeout);
            const playerInstance = playerInstanceRef.current;
            if (playerInstance && typeof playerInstance.off === "function") {
                try {
                    playerInstance.off("ready");
                    playerInstance.off("timeupdate");
                    playerInstance.off("play");
                    playerInstance.off("pause");
                    playerInstance.off("ended");
                    playerInstance.off("error");
                    playerInstance.off("volumechange");
                } catch (e) {
                    // Optionally log the error for debugging
                    // console.warn('Error during player cleanup:', e);
                }
                playerInstanceRef.current = null;
            }
            setPlayer(null);
            setIsReady(false);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [chapters, activeChapterIndex]);

    // Reset seek flag if initialChapterIndex changes
    useEffect(() => {
        hasInitialSeekDoneRef.current = false;
        setActiveChapterIndex(
            Math.max(0, Math.min(initialChapterIndex, (chapters?.length || 1) - 1))
        );
    }, [initialChapterIndex, chapters]);

    // Check scroll state on mount and when chapters change
    useEffect(() => {
        checkScrollState();
    }, [chapters]);

    useEffect(() => {
        if (!thumbnailWrapperRef.current || !chapters?.length) {
            return;
        }

        const container = thumbnailWrapperRef.current;
        const containerDimensions = {
            offsetWidth: container.offsetWidth,
            offsetHeight: container.offsetHeight,
            scrollWidth: container.scrollWidth,
            scrollHeight: container.scrollHeight
        };

        if (containerDimensions.offsetWidth === 0 || containerDimensions.offsetHeight === 0) {
            window.setTimeout(() => {
                if (thumbnailWrapperRef.current) {
                    setActiveChapterIndex(current => current);
                }
            }, NUMBER.FIFTY);
            return;
        }

        const isVerticalLayout = source === PAGE_SOURCE.VIDEO_GALLERY;
        if (isVerticalLayout) {
            const THUMBNAIL_HEIGHT = NUMBER.FIFTY_TWO;
            const THUMBNAIL_GAP = NUMBER.TWENTY;
            const containerHeight = container.offsetHeight;
            const chapterHeight = THUMBNAIL_HEIGHT + THUMBNAIL_GAP;
            const activeChapterPosition = activeChapterIndex * chapterHeight;
            const centerOffset = containerHeight / NUMBER.TWO - THUMBNAIL_HEIGHT / NUMBER.TWO;
            let scrollPosition = activeChapterPosition - centerOffset;
            const maxScroll = container.scrollHeight - containerHeight;
            scrollPosition = Math.max(0, Math.min(scrollPosition, maxScroll));
            container.scrollTo({
                top: scrollPosition,
                behavior: "smooth"
            });
        } else {
            const THUMBNAIL_WIDTH = 66;
            const THUMBNAIL_MARGIN = NUMBER.TWENTY;
            const containerWidth = container.offsetWidth;
            const currentScrollLeft = container.scrollLeft;
            const chapterWidth = THUMBNAIL_WIDTH + THUMBNAIL_MARGIN;

            const activeChapterLeft = activeChapterIndex * chapterWidth;
            const activeChapterRight = activeChapterLeft + THUMBNAIL_WIDTH;
            const viewportLeft = currentScrollLeft;
            const viewportRight = currentScrollLeft + containerWidth;

            const isChapterVisible = activeChapterLeft >= viewportLeft && activeChapterRight <= viewportRight;

            if (!isChapterVisible) {
                let scrollPosition;

                if (activeChapterLeft < viewportLeft) {
                    scrollPosition = activeChapterLeft - THUMBNAIL_MARGIN;
                } else if (activeChapterRight > viewportRight) {
                    scrollPosition = activeChapterRight - containerWidth + THUMBNAIL_MARGIN;
                } else {
                    const centerOffset = containerWidth / NUMBER.TWO - THUMBNAIL_WIDTH / NUMBER.TWO;
                    scrollPosition = activeChapterLeft - centerOffset;
                }

                const maxScroll = container.scrollWidth - containerWidth;
                scrollPosition = Math.max(0, Math.min(scrollPosition, maxScroll));

                if (Math.abs(scrollPosition - currentScrollLeft) > 1) {
                    container.scrollTo({
                        left: scrollPosition,
                        behavior: "smooth"
                    });
                }
            }
        }
    }, [activeChapterIndex, chapters, source]);

    const seekToTimestamp = (seconds, index) => {
        if (player && isReady) {
            player.setCurrentTime(seconds);
            setActiveChapterIndex(index);
        }
        trackDesktopCustomEventsAU(VIDEO_CATALOG_AMPLITUDE_EVENTS.VIDEO_CHAPTER_SELECTED, {
            ...VIDEO_CATALOG_GA_EVENTS_DESKTOP.VIDEO_CHAPTER_SELECTED,
            eventLabel: chapters[index].label,
            eventAction: "chapter_name"
        });
    };

    const handleWishlistClick = () => {
        ctaHook.onWishlistClick();
        trackDesktopCustomEventsAU(VIDEO_CATALOG_AMPLITUDE_EVENTS.VIDEO_CAR_WISHLIST, {
            ...VIDEO_CATALOG_GA_EVENTS_DESKTOP.VIDEO_CAR_WISHLIST,
            eventLabel: content.appointmentId,
            eventAction: isWishlistedCar(content.appointmentId) ? "off" : "on"
        });
    };

    const viewDetailsClick = () => {
        if (player && isReady) {
            player.pause();
        }
        window.open(relativeURL, "_blank", "noopener,noreferrer");
        trackDesktopCustomEventsAU(VIDEO_CATALOG_AMPLITUDE_EVENTS.VIDEO_VIEW_ALL_DETAILS, {
            ...VIDEO_CATALOG_GA_EVENTS_DESKTOP.VIDEO_VIEW_ALL_DETAILS,
            eventLabel: content.appointmentId,
            eventAction: "video_view_all_details"
        });
    };

    const toggleMute = () => {
        if (player && isReady) {
            player.getMuted((actualPlayerState) => {
                if (actualPlayerState) {
                    player.unmute();
                    setIsMuted(false);
                } else {
                    player.mute();
                    setIsMuted(true);
                }
                trackDesktopCustomEventsAU(VIDEO_CATALOG_AMPLITUDE_EVENTS.VIDEO_MUTE, {
                    ...VIDEO_CATALOG_GA_EVENTS_DESKTOP.VIDEO_MUTE,
                    eventLabel: content.appointmentId,
                    eventAction: actualPlayerState ? "off" : "on"
                });
            });
        }
    };

    const handleLeftArrowClick = () => {
        if (thumbnailWrapperRef.current) {
            const container = thumbnailWrapperRef.current;
            const scrollAmount = container.offsetWidth / NUMBER.TWO;
            container.scrollBy({
                left: -scrollAmount,
                behavior: "smooth"
            });
            // Check scroll state after animation completes
            window.setTimeout(checkScrollState, NUMBER.THREE_HUNDRED);
            trackDesktopCustomEventsAU(VIDEO_CATALOG_AMPLITUDE_EVENTS.CHAPTER_CAROUSEL_SCROLLED, {
                ...VIDEO_CATALOG_GA_EVENTS_DESKTOP.CHAPTER_CAROUSEL_SCROLLED
            });
        }
    };

    const handleRightArrowClick = () => {
        if (thumbnailWrapperRef.current) {
            const container = thumbnailWrapperRef.current;
            const scrollAmount = container.offsetWidth / NUMBER.TWO;
            container.scrollBy({
                left: scrollAmount,
                behavior: "smooth"
            });
            // Check scroll state after animation completes
            window.setTimeout(checkScrollState, NUMBER.THREE_HUNDRED);
            trackDesktopCustomEventsAU(VIDEO_CATALOG_AMPLITUDE_EVENTS.CHAPTER_CAROUSEL_SCROLLED, {
                ...VIDEO_CATALOG_GA_EVENTS_DESKTOP.CHAPTER_CAROUSEL_SCROLLED
            });
        }
    };

    const chapterDivStyle = source === PAGE_SOURCE.VIDEO_GALLERY ? "styles.gallerythumbnailWrapper" : "styles.thumbnailWrapper";
    const mainWrapper = source === PAGE_SOURCE.VIDEO_GALLERY ? "styles.videoGalleryMainWrapper" : "styles.mainWrapper";
    const thumbnailTextStyle = source === PAGE_SOURCE.VIDEO_GALLERY ? "styles.videoGalleryThumbnailText" : "styles.thumbnailText";
    const thumbnailTextActiveStyle = source === PAGE_SOURCE.VIDEO_GALLERY ? "styles.videoGalleryThumbnailTextActive" : "styles.thumbnailTextActive";
    const muteContainerStyle = source === PAGE_SOURCE.CDP ? "styles.muteContainer" : "styles.muteContainerListing";
    const mainImageWrapStyle = source === PAGE_SOURCE.VIDEO_GALLERY ? "styles.videoGalleryMainImageWrap" : "styles.mainImageWrap";

    const handleThumbnailScroll = useDebouncedScroll(() => {
        checkScrollState();
        trackDesktopCustomEventsAU(VIDEO_CATALOG_AMPLITUDE_EVENTS.CHAPTER_CAROUSEL_SCROLLED, {
            ...VIDEO_CATALOG_GA_EVENTS_DESKTOP.CHAPTER_CAROUSEL_SCROLLED
        });
    });

    return (
        <div styleName={"styles.outer"}>
            <div styleName={mainWrapper}>
                {
                    source === PAGE_SOURCE.CDP && (
                        <div onClick={onClose} styleName={"styles.closeWrapper"}>
                            <p styleName={"styles.close"}>Close<img src={closeIcon} alt="close" /></p>
                        </div>
                    )
                }
                <div styleName={mainImageWrapStyle}>
                    <div style={{
                        position: "relative",
                        width: "100%",
                        height: "100%",
                        maxWidth: "min(400px, calc(100vh - 200px) * 9 / 16)",
                        aspectRatio: "9 / 16",
                        margin: "0 auto"
                    }}>
                        <iframe
                            ref={iframeRef}
                            width="100%"
                            height="100%"
                            src={getVideoPlayerUrlWithUserData()}
                            title="Gumlet video player"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
                            style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                borderRadius: 8,
                                background: "#000"
                            }}
                        />
                    </div>
                    {/* <div styleName={"styles.topIconWrap"}>
                        <div onClick={ctaHook.onWishlistClick} styleName={"styles.iconWrapper"}>
                            <img src={isWishlistedCar(content.appointmentId) ? wishlistFilledIcon : wishlistIcon} alt="wishlist" />
                        </div>
                        <div styleName={"styles.iconWrapper"} onClick={toggleMute} style={{ cursor: "pointer" }}>
                            <img src={isMuted ? unmuteIcon : muteIcon} alt={isMuted ? "Mute" : "Unmute"} />
                        </div>
                    </div> */}
                    <div styleName={muteContainerStyle}>
                        <div styleName={"styles.iconWrapper"}>
                            <img onClick={handleWishlistClick} src={isWishlistedCar(content.appointmentId) ? wishlistFilledIcon : wishlistIcon} />
                        </div>
                        <div styleName={"styles.iconWrapper"} onClick={toggleMute} style={{ cursor: "pointer" }}>
                            <img src={isMuted ? unmuteIcon : muteIcon} alt={isMuted ? "Unmute" : "Mute"} />
                        </div>
                    </div>
                </div>
                <div style={source !== PAGE_SOURCE.VIDEO_GALLERY ? {position: "relative"} : {position: "relative", overflow: "auto"}}>
                    {
                        source !== PAGE_SOURCE.VIDEO_GALLERY && canScrollLeft && (
                            <div styleName="styles.leftArrow">
                                <img onClick={handleLeftArrowClick} src={left}/>
                            </div>
                        )
                    }
                    <div styleName={chapterDivStyle} ref={thumbnailWrapperRef} onScroll={handleThumbnailScroll}>
                        {
                                chapters?.map((chapter, index) => (
                                    <div
                                        styleName={`styles.thumbnail${index === activeChapterIndex ? " styles.thumbnailActive" : ""}`}
                                        key={index}
                                        onClick={() => seekToTimestamp(chapter.startTime, index)}
                                    >
                                        <div styleName={"styles.tumbnailImage"}>
                                            <img src={chapter.circularThumbnailUrl} alt={`Chapter ${index + 1}`} />
                                        </div>
                                        <p styleName={`${index === activeChapterIndex ? thumbnailTextActiveStyle : thumbnailTextStyle}`}>{chapter.label}</p>
                                    </div>
                                ))
                        }

                    </div>
                    {
                        source !== PAGE_SOURCE.VIDEO_GALLERY && canScrollRight && (
                            <div styleName="styles.rightArrow">
                                <img onClick={handleRightArrowClick} src={right}/>
                            </div>
                        )
                    }
                </div>

            </div>
            {
                (source === PAGE_SOURCE.CLP || source === PAGE_SOURCE.HOME_PAGE) && (
                    <React.Fragment>
                        <div styleName={"styles.bottomSectionWrapper"}>
                            <div onClick={onClose} styleName={"styles.closeWrapper"}>
                                <p styleName={"styles.close"}>Close<img src={closeIcon} alt="close" /></p>
                            </div>
                            <CarDetailsCardRevamp
                                content={content}
                                ctaProps={ctaHook.cta}
                                comingSoon={content.comingSoon}
                                calculatorRef={calculatorRef}
                                scrollToSection={scrollToSection}
                                onWishlistClick={ctaHook.onWishlistClick}
                                isWishlisted={isWishlistedCar(content.appointmentId)}
                                onClickNotifyIcon={ctaHook.onClickNotifyIcon}
                                isFetchingOrderDetails={isFetchingOrderDetails}
                                source={PAGE_SOURCE.VIDEO_GALLERY}
                                viewDetailsClick={viewDetailsClick}
                                comingSoonExperiment={desktopComingSoon}
                            />
                        </div>
                    </React.Fragment>
                )
            }
            {
                ctaHook.carReservationModalOpen && (
                    <CarReservationNotifyModal
                        isOpen={ctaHook.carReservationModalOpen}
                        notifyIconCliked={ctaHook.notifyIconCliked}
                        onClickNotifyIcon={ctaHook.onClickNotifyIcon}
                        cta={ctaHook.cta}
                        reserved={content.reserved}
                        isWishlistedCar={isWishlistedCar(content.appointmentId)}
                        onWishlistClick={ctaHook.onWishlistClick}
                        wishlistActionCompleted={ctaHook.wishlistActionCompleted}
                        handleCarReservationModal={ctaHook.handleCarReservationModal}
                    />
                )
            }
        </div>
    );
};

VideoGallerySlider.propTypes = {
    onClose: PropTypes.func,
    showModal: PropTypes.bool,
    chapters: PropTypes.arrayOf(
        PropTypes.shape({
            startTime: PropTypes.number.isRequired,
            endTime: PropTypes.number.isRequired,
            thumbnailUrl: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
            key: PropTypes.string,
            previewUrl: PropTypes.string,
            circularThumbnailUrl: PropTypes.string
        })
    ),
    videoUrl: PropTypes.string,
    content: PropTypes.object,
    source: PropTypes.string,
    isWishlistedCar: PropTypes.bool,
    config: PropTypes.object,
    orderStatus: PropTypes.string,
    secureToken: PropTypes.string,
    onClickAddToWishList: PropTypes.func,
    isLoggedIn: PropTypes.bool,
    onWishlistClick: PropTypes.func,
    isWishlisted: PropTypes.bool,
    orderId: PropTypes.string,
    createOrderConnect: PropTypes.func,
    isExtendedWarrantySelected: PropTypes.bool,
    isFinanceFirstCheckout: PropTypes.bool,
    updateOrderConnect: PropTypes.func,
    updateValidC2bOrderConnect: PropTypes.func,
    setCheckoutLoginTypeConnect: PropTypes.func,
    openLoginPopupConnect: PropTypes.func,
    setOnLoginSuccessCallback: PropTypes.func,
    egc: PropTypes.number,
    showTradeInCheckoutStep: PropTypes.bool,
    eligibleForExtendedWarranty: PropTypes.bool,
    preApproved: PropTypes.bool,
    financeOpted: PropTypes.bool,
    financeProvider: PropTypes.string,
    preApprovalType: PropTypes.string,
    financeFirstCheckoutRevamp: PropTypes.bool,
    DRIVA_MIN_LOAN_AMOUNT_OFFERED: PropTypes.number,
    testDriveStatus: PropTypes.string,
    isUserZeroDpVariant: PropTypes.bool,
    initialChapterIndex: PropTypes.number,
    calculatorRef: PropTypes.object,
    scrollToSection: PropTypes.func,
    isFetchingOrderDetails: PropTypes.bool,
    isKbbShown: PropTypes.bool,
    handleKbbModal: PropTypes.func,
    ctaProps: PropTypes.object,
    drivingLicenceStatus: PropTypes.string,
    fetchSimilarCarsConnect: PropTypes.func,
    fireEwSkippedCTEvent: PropTypes.func,
    order: PropTypes.object,
    step: PropTypes.object,
    carDetails: PropTypes.object,
    getCheckoutStepsConnect: PropTypes.func,
    getOrderDetailConnect: PropTypes.func,
    userGeoData: PropTypes.object,
    testDriveConfig: PropTypes.object,
    gaId: PropTypes.string,
    email: PropTypes.string,
    leadAppointment: PropTypes.object,
    createClassifiedLeadConnect: PropTypes.func,
    phoneNumberVerified: PropTypes.bool,
    desktopComingSoon: PropTypes.object
};

export default VideoGallerySlider;
